import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class Button extends Component {
  static propTypes = {
    callback: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
  };

  render() {
    const { callback, className, autoFocus, disabled } = this.props;

    const disabledState = disabled || false;

    return (
      <button
        autoFocus={autoFocus}
        disabled={disabledState}
        className={className || 'btn btn-default'} // {...this.props}
        onClick={callback}
        {...this.props}
      >
        {this.props.children}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/BasicButton/Button.js